import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

export interface UserPrivacyPreferences {
  postsVisibleToConsumer: boolean
  transactionsVisibleToConsumer: boolean
}

const getUserPrivacyPreferences = async (userId: number): Promise<UserPrivacyPreferences> => {
  try {
    const response = await getRequest<UserPrivacyPreferences>(`/users/preferences/privacy?user_id=${userId}`)
    if (!response) {
      throw new Error('Privacy preferences not found')
    }

    return response
  } catch (error) {
    throw new Error(`Failed to fetch privacy preferences | ${error}`)
  }
}

export function useUserPrivacyPreferences(userId: number) {
  return useSuspenseQuery({
    ...queries.users.me._ctx.privacyPreferences(userId),
    queryFn: () => getUserPrivacyPreferences(userId),
  })
}
